import { createSelector } from 'reselect'
import { getCustomer } from 'helpers'

// TODO: refactor

const select = (state) => state.favourites

const favourite = (state, props) => {
  const includes = state.favourites.items.filter(
    (item) =>
      item.contentId === props.contentId && item.customer === getCustomer()
  )
  return !!includes.length
}

const selectIsFavourite = createSelector(favourite, (favourite) => favourite)

const selectFavourites = createSelector(
  select,
  (favourites) => favourites.items
)

const selectFaqs = createSelector(selectFavourites, (favourites) =>
  favourites.filter((fav) => fav.contentType === 'faq')
)

const selectTutorials = createSelector(selectFavourites, (favourites) =>
  favourites.filter((fav) => fav.contentType === 'tutorial')
)

export { selectIsFavourite, selectFavourites, selectFaqs, selectTutorials }
